import styled from 'styled-components'

import theme from 'theme_'
import { H1 } from 'components/Typography'

const { spacing } = theme

export const BillingHistoryHeading = styled(H1)`
  margin-bottom: ${spacing.base};
`

export const BillingHistoryPageWrapper = styled.div`
  margin: ${spacing.lg} ${spacing.sm} ${spacing.lg};
`

export const BillingHistoryLoadWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing.sm};
`
